import { configValue } from 'utils/config';

const optimizations = ['cache=expiry:31536000', 'compress', 'no_metadata'].join(
  '/'
);

type Props = {
  handle: string;
  transform?: string;
  format?: string;
  mimetype?: string;
};

export function imageUrl({ handle, transform, format, mimetype }: Props) {
  const mockValue = configValue('filestack', 'mock');
  if (mockValue) {
    if (mockValue === 'storybook') return `/storybook-fake/${handle}`;

    return `/lolz/image/${transform ? `${transform}/` : ''}${
      format ? `output=format:${format}/` : ''
    }${optimizations}/${handle}`;
  }

  // transforms are not supported for svg
  if (mimetype && mimetype.includes('image/svg')) {
    return `https://process.filestackapi.com/output=secure:true/${optimizations}/${handle}`;
  }

  return `https://process.filestackapi.com/${transform ? `${transform}/` : ''}${
    format ? `output=format:${format}/` : ''
  }${optimizations}/${handle}`;
}

export const imageSizeUrl = ({ handle }: { handle: string }) =>
  configValue('filestack', 'mock')
    ? '/lolz/image-size'
    : `https://cdn.filestackcontent.com/imagesize/${handle}`;
